import { render, staticRenderFns } from "./activity-assignments.vue?vue&type=template&id=46b9a599&scoped=true"
import script from "./activity-assignments.vue?vue&type=script&lang=js"
export * from "./activity-assignments.vue?vue&type=script&lang=js"
import style0 from "./activity-assignments.vue?vue&type=style&index=0&id=46b9a599&prod&lang=css"
import style1 from "./activity-assignments.vue?vue&type=style&index=1&id=46b9a599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9a599",
  null
  
)

export default component.exports